<div class="w-full flex flex-col p-5">
  <h3 class="font-bold">کد تایید را وارد کنید</h3>
  <p class="w-full my-3">کد تایید 6 رقمی به <b>{{phoneNumber}}</b> ارسال شد.</p>

  <h5 class="font-bold text-blue-500 mt-5 cursor-pointer" (click)="emitStep('step-register')">اصلاح شماره موبایل</h5>

  <div class="w-full my-5">


    <div class="otp-container  flex flex-row-reverse">
      <div *ngFor="let digit of otpDigits; let i = index" class="otp-digit mx-2">
        <input (paste)="onInputPaste($event)" [attr.maxlength]="1"
          class="text-center shadow border-2 {{ errCode ? '!border-red-400 border-solid' : ''}} appearance-none  rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
          id="otp-digit-{{i}}" type="number" placeholder="-" [ngModel]="otp[i] " type="tel" #otpInput
          (input)="onInput($event, i)" />
      </div>
      <input type="hidden" (change)="changeAbort($event)" autocomplete="one-time-code" [(ngModel)]="myOTP"
        inputmode="numeric">
    </div>
    <span class="text-red-400 text-xs mt-2" *ngIf="errCode"> {{codeErr}} </span>

    <div class="w-full my-4">
      <div class="pe-2 text-muted w-[50px] float-right">
        <span>{{displayTimer}} </span>
      </div>
      <span class="text-sm text-muted"> تا درخواست مجدد کد </span>
      <button [disabled]="!refreshOTP" (click)="refreshOTP ? timerAgain() : null" class="float-left text-sm flex items-center  {{refreshOTP ? 'text-blue-500 cursor-pointer' : 'text-muted' }}
          font-bold ">ارسال
        مجدد
        <i class="ico-RotateRight mx-2 font-bold"></i>
      </button>

    </div>

  </div>
  <button mat-raised-button color="primary" [disabled]="disabledBtn || showLoading" class="!font-bold !text-base !h-11"
    (click)="!disabledBtn ? emitStep('step-new-pass') : null">
    <div class="typing-animation" *ngIf="showLoading">
      <span></span>
      <span></span>
      <span></span>
    </div>
    <span *ngIf="!showLoading">
      تایید و
      ادامه
    </span>
  </button>

</div>